import { EXPERIMENT_VARIATION } from 'shared/experiments/consts'
import { isMobile } from 'shared/utils/deviceClassUtils'
import { TOP_DEAL_PRODUCT_IDS } from 'views/components/organisms/FilteredProductList/SearchProductListItem/consts'

export const getAmount = ({ unitQuantityString, unit }) => {
  if (!unitQuantityString || !unit) {
    return null
  }
  return `${unitQuantityString} ${unit}`
}

export const resolveLazyLoad = (deviceClass, index, lazyLoad = null) => {
  if (lazyLoad != null) {
    return lazyLoad
  }

  if (index === -1) {
    return true
  }

  return isMobile(deviceClass) ? index > 1 : index > 3
}

export const calculateSliderImageSize = columns => {
  const viewportPercentage = Math.ceil(100 / columns)
  const margin = Math.ceil(
    // padding on both sides of the whole content
    2 / columns +
      // gap between each column
      0.5 +
      // padding on both sides of the image
      2
  )
  return `calc(${viewportPercentage}vw - ${margin}rem)`
}

export const shouldRenderTopDealLabel = (topDealExperiment, productId) => {
  return (
    topDealExperiment?.isEnabled &&
    (topDealExperiment?.variant === EXPERIMENT_VARIATION.V1 ||
      topDealExperiment?.variant === EXPERIMENT_VARIATION.V2) &&
    TOP_DEAL_PRODUCT_IDS.includes(productId)
  )
}
